import { render, staticRenderFns } from "./ResultsSummary.vue?vue&type=template&id=da44668e&scoped=true"
import script from "./ResultsSummary.vue?vue&type=script&lang=ts"
export * from "./ResultsSummary.vue?vue&type=script&lang=ts"
import style0 from "./ResultsSummary.vue?vue&type=style&index=0&id=da44668e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da44668e",
  null
  
)

export default component.exports